import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, Item, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions, TabbedItem, TabPanelOptions, Tab
} from 'devextreme-react/form';
import { Solicitar, Insertar, Modificar } from "../../Hooks/PeticiondeRegistros";
import ComboAbmEexClientes from "../Compuestos/Combos/ComboAbmEexClientes";
import ComboAbmEexProveedores from "../Compuestos/Combos/ComboAbmEexProveedores";
import ComboAbmEexProfesionales from "../Compuestos/Combos/ComboAbmEexProfesionales";
import ComboAbmTraTransportistas from "../Compuestos/Combos/ComboAbmTraTransportistas";
import ComboAbmZonPlantas from "../Compuestos/Combos/ComboAbmZonPlantas";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import LV_EEX_PersonasLocaciones from "../Compuestos/Complejos/Personas/LV_EEX_PersonasLocaciones";
import { LVGridCarga } from "../Basicos/LVGridCarga";
import { Column } from "devextreme-react/data-grid";
import { LVForm } from "../Basicos/LVForm";
import { function_ABM_EEX_Personas_Generar_JSON, function_ABM_EEX_Personas_Insertar, function_ABM_EEX_Personas_Leer, function_ABM_EEX_Personas_Modificar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Personas";
import ComboAbmEexPersonasTipos from "../Compuestos/Combos/ComboAbmEexPersonasTIpos";
import { function_ABM_EEX_Clientes_InsertarBasico } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import { function_ABM_EEX_Proveedores_Generar_JSON, function_ABM_EEX_Proveedores_Insertar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Proveedores";
import { function_ABM_EEX_Profesionales_Generar_JSON, function_ABM_EEX_Profesionales_Insertar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Profesionales";
import { function_VEN_ABM_EEX_PersonasLocaciones_Eliminar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_PersonasLocaciones";

const ABM_EEX_Personas = (props) => {
  const [idProveedor, setIdProveedor] = useState(null);
  const [idCliente, setIdCliente] = useState(null);
  const [idTransportista, setIdTransportista] = useState(null);
  const [idProfesional, setIdProfesional] = useState(null);
  const [idTipoPersona, setIdTipoPersona] = useState(0);
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [esUsuario, setEsUsuario] = useState(false);
  const [esAdmin, setEsAdmin] = useState(false);
  const [esMultiEmpresa, setEsMultiEmpresa] = useState(true);
  const [esMultiPlanta, setEsMultiPlanta] = useState(true);
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(null);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [reloadTransportistas, setReloadTransportistas] = useState(false);
  const [reloadProfesionales, setReloadProfesionales] = useState(false);
  const [reloadProveedores, setReloadProveedores] = useState(false);
  const [reloadClientes, setReloadClientes] = useState(false);

  const handleOnValueChangedMultiEmpresa = (e) => {
    const isChecked = e.value;

    setEsMultiEmpresa(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiEmpresa: isChecked
    }));
  };

  const handleOnValueChangedMultiPlanta = (e) => {
    const isChecked = e.value;

    setEsMultiPlanta(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiPlanta: isChecked
    }));
  };

  const handleOnClick_AgregarPlanta = async (e) => {
    if (!plantaSeleccionada.codigo) {
      alert("Seleccione una Planta antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const plantaYaExiste = datos.ListPlantas?.some(
      (planta) => planta.ABM_ZON_Plantas_CodigoPlanta === plantaSeleccionada.codigo
    );

    if (plantaYaExiste) {
      alert("La Planta ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaPlanta = {
      ABM_ZON_Plantas_CodigoPlanta: plantaSeleccionada.codigo,
      CodigoPlanta: plantaSeleccionada.codigo,
      Descripcion: plantaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListPlantas: [...(prevDatos.ListPlantas || []), nuevaPlanta],
    }));

    // Limpiar la selección después de agregar
    setPlantaSeleccionada(null);
  }

  const handleOnClick_AgregarEmpresa = async (e) => {
    if (!empresaSeleccionada.codigo) {
      alert("Seleccione una Empresa antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const empresaYaExiste = datos.ListEmpresas?.some(
      (empresa) => empresa.ABM_ZON_Empresas_CodigoEmpresa === empresaSeleccionada.codigo
    );

    if (empresaYaExiste) {
      alert("La Empresa ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaEmpresa = {
      ABM_ZON_Empresas_CodigoEmpresa: empresaSeleccionada.codigo,
      CodigoEmpresa: empresaSeleccionada.codigo,
      Descripcion: empresaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListEmpresas: [...(prevDatos.ListEmpresas || []), nuevaEmpresa],
    }));

    // Limpiar la selección después de agregar
    setEmpresaSeleccionada(null);
  }

  const handleOnClickGuardar = async (e) => {
    try {

      if (!datos.RazonSocial || datos.RazonSocial.trim() === "") {
        datos.RazonSocial = `${datos.Nombre || ""} ${datos.Apellido || ""}`.trim();
      }

      const JSON = await function_ABM_EEX_Personas_Generar_JSON(
        datos.IdPersona,
        datos.MultiPlanta,
        datos.MultiEmpresa,
        datos.UserId,
        datos.Apellido,
        datos.Nombre,
        datos.Email,
        datos.Login,
        datos.Password,
        datos.CUIT,
        datos.TieneAgenda,
        datos.ColorAgenda,
        datos.Admin,
        datos.HuellaDactilar,
        datos.HuellaDactilarString,
        datos.CodigoDispositivoControlHorario,
        datos.EsSoloPVenta,
        datos.PuedeRetirarDinero,
        datos.PuedeAutorizarGastos,
        datos.PuedeAutorizarConsumisiones,
        idProveedor,
        idCliente,
        idTransportista,
        idProfesional,
        datos.CodigoTransporteActual,
        datos.FechaAsignacionTransporteActual,
        datos.PathTerminal,
        idTipoPersona,
        datos.HabilitadoAutorizarGastos,
        datos.HabilitadoAutorizarConsumisiones,
        datos.HabilitadoAutorizarNC,
        datos.HabilitadoAutorizarDescuentos,
        datos.HabilitadoRecepcionMail,
        datos.HabilitadoAutorizarRetiroDinero,
        datos.EsSocio,
        datos.OpAutGenera,
        datos.OpAutIdProveedor,
        datos.OpAutIdTipoDocCompra,
        datos.OpAutCodigoSubCC,
        datos.OpAutCodigoCuentaFinanciera,
        datos.OpAutCodigoPlantaCompra,
        datos.SubidoEnNube,
        datos.ListPlantas,
        datos.ListEmpresas
      )

      console.log(JSON)
      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_EEX_Personas_Insertar(JSON, false)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_EEX_Personas_Modificar(JSON, false)

        alert("Se ha modificado el Código: " + datos.IdPersona)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClickCrearCliente = async (e) => {
    if (!datos.Nombre || datos.Nombre.trim() === "") {
      alert("Debe completar el campo NOMBRE antes de continuar.");
      return;
    }

    if (!datos.Apellido || datos.Apellido.trim() === "") {
      alert("Debe completar el campo APELLIDO antes de continuar.");
      return;
    }

    if (!datos.CUIT || datos.CUIT.trim() === "") {
      alert("Debe completar el campo CUIT antes de continuar.");
      return;
    }

    if (!datos.Codigo || datos.Codigo < 1) {
      alert("Esta función solo es válida para Personas ya creadas. Crear primero a la persona, luego editar y esta función se encontrará disponible.");
      return;
    }

    try {
      const resultCliente = await function_ABM_EEX_Clientes_InsertarBasico(datos.Apellido, datos.Nombre,
        datos.CUIT, null, null, datos.Email, null)

      setReloadClientes(true)

      setIdCliente(resultCliente.data.codigoGenerado)

      alert("Se ha creado el Cliente Nº " + resultCliente.data.codigoGenerado)
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClickCrearProveedor = async (e) => {
    if (!datos.Nombre || datos.Nombre.trim() === "") {
      alert("Debe completar el campo NOMBRE antes de continuar.");
      return;
    }

    if (!datos.Apellido || datos.Apellido.trim() === "") {
      alert("Debe completar el campo APELLIDO antes de continuar.");
      return;
    }

    if (!datos.CUIT || datos.CUIT.trim() === "") {
      alert("Debe completar el campo CUIT antes de continuar.");
      return;
    }

    if (!datos.Codigo || datos.Codigo < 1) {
      alert("Esta función solo es válida para Personas ya creadas. Crear primero a la persona, luego editar y esta función se encontrará disponible.");
      return;
    }

    try {
      const JSON = await function_ABM_EEX_Proveedores_Generar_JSON(0, true, true, datos.Nombre + " " + datos.Apellido, datos.Apellido,
        datos.Nombre, datos.CUIT, 1, null, "", null, null, null, null, null, null, null, null, null, null, null, null, null,
        null, null, null, null, [], [])
      const resultProveedor = await function_ABM_EEX_Proveedores_Insertar(JSON)

      setReloadProveedores(true)

      setIdProveedor(resultProveedor.data.codigoGenerado)

      alert("Se ha creado el Proveedor Nº " + resultProveedor.data.codigoGenerado)
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClickCrearProfesional = async (e) => {
    if (!datos.Nombre || datos.Nombre.trim() === "") {
      alert("Debe completar el campo NOMBRE antes de continuar.");
      return;
    }

    if (!datos.Apellido || datos.Apellido.trim() === "") {
      alert("Debe completar el campo APELLIDO antes de continuar.");
      return;
    }

    if (!datos.CUIT || datos.CUIT.trim() === "") {
      alert("Debe completar el campo CUIT antes de continuar.");
      return;
    }

    if (!datos.Codigo || datos.Codigo < 1) {
      alert("Esta función solo es válida para Personas ya creadas. Crear primero a la persona, luego editar y esta función se encontrará disponible.");
      return;
    }

    try {
      const JSON = await function_ABM_EEX_Profesionales_Generar_JSON(0, true, true, datos.Nombre + " " + datos.Apellido, datos.Apellido,
        datos.Nombre, datos.CUIT, null, null, null, null, null, null, null, null, null, null, null, datos.Email, null, null,
        null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, "1", idProveedor, datos.CUIT,
        null, null, null, null, null, null, null, null, null, null, datos.IdPersona, null, [], [])
      const resultProfesional = await function_ABM_EEX_Profesionales_Insertar(JSON)

      setReloadProfesionales(true)

      setIdProfesional(resultProfesional.data.codigoGenerado)

      alert("Se ha creado el Profesional Nº " + resultProfesional.data.codigoGenerado)
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClickCrearTransportista = async (e) => {
    if (!datos.Nombre || datos.Nombre.trim() === "") {
      alert("Debe completar el campo NOMBRE antes de continuar.");
      return;
    }

    if (!datos.Apellido || datos.Apellido.trim() === "") {
      alert("Debe completar el campo APELLIDO antes de continuar.");
      return;
    }

    if (!datos.CUIT || datos.CUIT.trim() === "") {
      alert("Debe completar el campo CUIT antes de continuar.");
      return;
    }

    if (!datos.Codigo || datos.Codigo < 1) {
      alert("Esta función solo es válida para Personas ya creadas. Crear primero a la persona, luego editar y esta función se encontrará disponible.");
      return;
    }

    try {
      /*
      const JSON = await function_ABM_tra_tr(0, true, true, datos.Nombre + " " + datos.Apellido, datos.Apellido,
        datos.Nombre, datos.CUIT, 1, null, "", null, null, null, null, null, null, null, null, null, null, null, null, null,
        null, null, null, null, [], [])
      const resultProfesional = await function_ABM_EEX_Profesionales_Generar_JSON(datos.Apellido, datos.Nombre,
        datos.CUIT, null, null, datos.Email, null)
        
      setReloadTransportistas(true)

      setIdTransportista(resultProfesional.data.codigoGenerado)

      alert("Se ha creado el Transportista Nº " + resultCliente.data.codigoGenerado)
      */
    } catch (error) {
      alert(error)
    }
  }

  const handleOnValueChangedEsUsuario = (e) => {
    const isChecked = e.value;
    setEsUsuario(isChecked);

    if (!isChecked) {
      setDatos((prevDatos) => ({
        ...prevDatos,
        Login: "",
        Password: "",
        Admin: false,
        EsSoloPVenta: false,
        PuedeRetirarDinero: false,
        PuedeAutorizarGastos: false,
        PuedeAutorizarConsumisiones: false,
        HabilitadoAutorizarGastos: false,
        HabilitadoAutorizarConsumisiones: false,
        HabilitadoAutorizarNC: false,
        HabilitadoAutorizarDescuentos: false,
        HabilitadoRecepcionMail: false,
        HabilitadoAutorizarRetiroDinero: false,
      }));
    }
  };

  const handleOnValueChangedEsAdmin = (e) => {
    const isChecked = e.value;
    setEsAdmin(isChecked);

    if (isChecked) {
      setDatos((prevDatos) => ({
        ...prevDatos,
        EsSoloPVenta: false,
      }));
    }
  };

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            IdPersona: 0,
            IdTipoPersona: 0,
            MultiPlanta: true,
            MultiEmpresa: true,
            UserId: null,
            Apellido: '',
            Nombre: '',
            Email: '',
            Login: '',
            Password: '',
            CUIT: '',
            TieneAgenda: false,
            ColorAgenda: null,
            Admin: false,
            HuellaDactilar: null,
            HuellaDactilarString: '',
            CodigoDispositivoControlHorario: '',
            EsSoloPVenta: false,
            PuedeRetirarDinero: false,
            PuedeAutorizarGastos: false,
            PuedeAutorizarConsumisiones: false,
            IdProveedor: 0,
            IdCliente: 0,
            IdTransportista: 0,
            IdProfesional: 0,
            CodigoTransporteActual: '',
            FechaAsignacionTransporteActual: '', //Date.now.setFullYear(1900).setMonth(1).setDay(1),
            PathTerminal: '',
            IdTipoPersona: 0,
            HabilitadoAutorizarGastos: false,
            HabilitadoAutorizarConsumisiones: false,
            HabilitadoAutorizarNC: false,
            HabilitadoAutorizarDescuentos: false,
            HabilitadoRecepcionMail: false,
            HabilitadoAutorizarRetiroDinero: false,
            EsSocio: false,
            OpAutGenera: false,
            OpAutIdProveedor: 0,
            OpAutIdTipoDocCompra: 0,
            OpAutCodigoSubCC: null,
            OpAutCodigoCuentaFinanciera: '',
            OpAutCodigoPlantaCompra: '',
            SubidoEnNube: false
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_EEX_Personas_Leer(props.Codigo.Codigo)
          if (datosDocumento.data.Login === "") {
            setEsUsuario(false)
          }
          else {
            setEsUsuario(true)
          }

          setDatos(datosDocumento.data)

          setEsMultiPlanta(datosDocumento.data.MultiPlanta)
          setEsMultiEmpresa(datosDocumento.data.MultiEmpresa)

          setIdProveedor(datosDocumento.data.IdProveedor)
          setIdCliente(datosDocumento.data.IdCliente)
          setIdProfesional(datosDocumento.data.IdProfesional)
          setIdTransportista(datosDocumento.data.IdTransportista)
          setIdTipoPersona(datosDocumento.data.IdTipoPersona)

          if (datosDocumento.data.Login === "") {
            setDatos((prevDatos) => ({
              ...prevDatos,
              EsUsuario: false,
            }));
          }
          else {
            setDatos((prevDatos) => ({
              ...prevDatos,
              EsUsuario: true,
            }));
          }
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={2}>
          <GroupItem caption="General">
            <SimpleItem dataField="IdPersona" disabled={true} >
              <Label text="Código" />
            </SimpleItem>
            <SimpleItem dataField="Nombre">
              <Label text="Nombre" />
              <RequiredRule message="Indicar el Nombre es obligatorio." />
            </SimpleItem>
            <SimpleItem dataField="Apellido">
              <Label text="Apellido" />
              <RequiredRule message="Indicar el Apellido es obligatorio." />
            </SimpleItem>
            <Item>
              <ComboAbmEexPersonasTipos
                ancho={"100%"}
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={idTipoPersona}
                onValueChanged={(e) => {
                  const descripcion = e.component?.option("text") || "";
                  setIdTipoPersona(e.value);
                  datos.IdTipoPersona = e.value
                }} />
            </Item>
          </GroupItem>

          <GroupItem caption="Detalles" colCount={2}>
            <SimpleItem dataField="CUIT" colSpan={2}>
              <Label text="C.U.I.T." />
            </SimpleItem>
            <SimpleItem dataField="Email" colSpan={2}>
              <Label text="E-Mail" />
            </SimpleItem>

            <SimpleItem dataField="Login" visible={esUsuario} >
              <Label text="Usuario" />
            </SimpleItem>
            <SimpleItem dataField="Password" visible={esUsuario} editorOptions={{ mode: "password" }}>
              <Label text="Contraseña" />
            </SimpleItem>
            <SimpleItem dataField="EsUsuario" editorType="dxCheckBox" editorOptions={{ onValueChanged: (e) => handleOnValueChangedEsUsuario(e) }}>
              <Label text="Es Usuario" />
            </SimpleItem>
            <SimpleItem dataField="EsSocio" editorType="dxCheckBox" visible={esUsuario} >
              <Label text="Socio" />
            </SimpleItem>
            <SimpleItem dataField="Admin" editorType="dxCheckBox" visible={esUsuario} editorOptions={{ onValueChanged: (e) => handleOnValueChangedEsAdmin(e) }}>
              <Label text="Administrador" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Relaciones">
            <Item>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <ComboAbmEexProveedores
                  ancho={300}
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={idProveedor}
                  reloadData={reloadProveedores}
                  onValueChanged={(e) => {
                    const descripcion = e.component?.option("text") || "";
                    setIdProveedor(e.value);
                    datos.IdProveedor = e.value
                  }} />

                <LVButtonAccion
                  Ancho={190}
                  Texto="CREAR PROVEEDOR"
                  visible={idProveedor < 1}
                  onClick={handleOnClickCrearProveedor}
                />
              </div>
            </Item>
            <Item>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <ComboAbmEexClientes
                  ancho={300}
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={idCliente}
                  reloadData={reloadClientes}
                  onValueChanged={(e) => {
                    const descripcion = e.component?.option("text") || "";
                    setIdCliente(e.value);
                    datos.IdCliente = e.value
                  }} />

                <LVButtonAccion
                  Ancho={190}
                  Texto="CREAR CLIENTE"
                  visible={idCliente < 1}
                  onClick={handleOnClickCrearCliente}
                />
              </div>
            </Item>
            <Item>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <ComboAbmTraTransportistas
                  ancho={300}
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={idTransportista}
                  reloadData={reloadTransportistas}
                  onValueChanged={(e) => {
                    const descripcion = e.component?.option("text") || "";
                    setIdTransportista(e.value);
                    datos.IdTransportista = e.value
                  }} />

                <LVButtonAccion
                  Ancho={190}
                  Texto="CREAR TRANSPORTISTA"
                  visible={idTransportista < 1}
                  onClick={handleOnClickCrearTransportista}
                />
              </div>
            </Item>
            <Item>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <ComboAbmEexProfesionales
                  ancho={300}
                  CodigoCompania={localStorage.getItem("CodigoCompania")}
                  CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                  CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                  value={idProfesional}
                  reloadData={reloadProfesionales}
                  onValueChanged={(e) => {
                    const descripcion = e.component?.option("text") || "";
                    setIdProfesional(e.value);
                    datos.IdProfesional = e.value
                  }} />

                <LVButtonAccion
                  Ancho={190}
                  Texto="CREAR PROFESIONAL"
                  visible={idProfesional < 1}
                  onClick={handleOnClickCrearProfesional}
                />
              </div>
            </Item>
          </GroupItem>

          <GroupItem caption="Permisos" colSpan={3} colCount={3} visible={esUsuario}>
            <SimpleItem dataField="EsSoloPVenta" editorType="dxCheckBox" visible={esUsuario && !esAdmin} >
              <Label text="Solo Punto de Venta" />
            </SimpleItem>
            <GroupItem caption="Autorizar sin Contraseña" colCount={1} visible={esUsuario}>
              <SimpleItem dataField="PuedeRetirarDinero" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="PuedeRetirarDinero" />
              </SimpleItem>
              <SimpleItem dataField="PuedeAutorizarGastos" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="PuedeAutorizarGastos" />
              </SimpleItem>
              <SimpleItem dataField="PuedeAutorizarConsumisiones" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="PuedeAutorizarConsumisiones" />
              </SimpleItem>
            </GroupItem>

            <GroupItem caption="Habilitaciones" colCount={1} visible={esUsuario}>
              <SimpleItem dataField="HabilitadoAutorizarGastos" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="HabilitadoAutorizarGastos" />
              </SimpleItem>
              <SimpleItem dataField="HabilitadoAutorizarConsumisiones" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="HabilitadoAutorizarConsumisiones" />
              </SimpleItem>
              <SimpleItem dataField="HabilitadoAutorizarNC" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="HabilitadoAutorizarNC" />
              </SimpleItem>
              <SimpleItem dataField="HabilitadoAutorizarDescuentos" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="HabilitadoAutorizarDescuentos" />
              </SimpleItem>
              <SimpleItem dataField="HabilitadoRecepcionMail" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="HabilitadoRecepcionMail" />
              </SimpleItem>
              <SimpleItem dataField="HabilitadoAutorizarRetiroDinero" editorType="dxCheckBox" visible={esUsuario} >
                <Label text="HabilitadoAutorizarRetiroDinero" />
              </SimpleItem>
            </GroupItem>
          </GroupItem>
        </Tab>

        <Tab title="Locaciones" visible={esModificacion}>
          <GroupItem>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {datos.Locaciones?.map((loc, index) => (
                <div className="LV-GroupBox-div" key={index} style={{ position: "relative", padding: "10px" }}>
                  <LV_EEX_PersonasLocaciones
                    index={index}
                    datos={datos}
                    setDatos={setDatos}
                  />
                  <button
                    onClick={async () => {
                      const nuevasLocaciones = [...datos.Locaciones];
                      const locAEliminar = nuevasLocaciones[index];

                      if (locAEliminar?.IdPersona && locAEliminar?.CodigoLocacionPersona) {
                        const confirmacion = window.confirm("¿Seguro que querés eliminar esta locación?");
                        if (!confirmacion) return;

                        try {
                          await function_VEN_ABM_EEX_PersonasLocaciones_Eliminar(locAEliminar.IdPersona, locAEliminar.CodigoLocacionPersona);
                          alert("Locación eliminada con éxito del servidor.");
                        } catch (error) {
                          alert("Error al eliminar la locación: " + error.message);
                          return;
                        }
                      }

                      nuevasLocaciones.splice(index, 1);
                      setDatos((prev) => ({
                        ...prev,
                        Locaciones: nuevasLocaciones
                      }));
                    }}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "#900",
                      fontWeight: "bold",
                      fontSize: "18px",
                      cursor: "pointer"
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}
              <LVButtonAccion
                Texto="AGREGAR LOCACIÓN"
                onClick={() => {
                  const nuevaLocacion = {
                    CodigoLocacionPersona: "",
                    IdTipoLocacion: "",
                    Calle: "",
                    Numero: "",
                    Piso: "",
                    Depto: "",
                    CodigoPostal: "",
                    IdPais: "",
                    Email: "",
                    Telefono: "",
                    TelefonoFax: "",
                    TelefonoCelular: "",
                    HorarioAtencion: "",
                    Responsable1: "",
                    Responsable2: "",
                    Responsable3: "",
                    Observaciones: "",
                    EsDefaultParaRemito: false,
                    IdCiudad: "",
                    DomicilioFacturacion: false,
                    CodigoEmpresaTransporte: "",
                    CodigoLocacionEmpresaTransporte: "",
                    CodigoZona: "",
                    Coordenadas: ""
                  };
                  setDatos((prev) => ({
                    ...prev,
                    Locaciones: [...(prev.Locaciones || []), nuevaLocacion]
                  }));
                }}
              />
            </div>
          </GroupItem>
        </Tab>

        <Tab title="Plantas">
          <GroupItem>
            <SimpleItem dataField="MultiPlanta" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiPlanta(e) }}>
              <Label text="MultiPlanta (Desactivado permite definir para que Plantas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiPlanta}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonPlantas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setPlantaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR PLANTA"} onClick={handleOnClick_AgregarPlanta} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListPlantas}
              keyExpr="ABM_ZON_Plantas_CodigoPlanta"
            >
              <Column caption="Código" dataField="ABM_ZON_Plantas_CodigoPlanta" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Empresas">
          <GroupItem>
            <SimpleItem dataField="MultiEmpresa" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiEmpresa(e) }}>
              <Label text="MultiEmpresa (Desactivado permite definir para que Empresas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiEmpresa}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonEmpresas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setEmpresaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR EMPRESA"} onClick={handleOnClick_AgregarEmpresa} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListEmpresas}
              keyExpr="ABM_ZON_Empresas_CodigoEmpresa"
            >
              <Column caption="Código" dataField="ABM_ZON_Empresas_CodigoEmpresa" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>
      </TabbedItem>

      <ButtonItem horizontalAlignment="Center" colSpan={3}>
        <ButtonOptions onClick={handleOnClickGuardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_EEX_Personas;